module.exports = __webpack_public_path__ + "48f3883f7e71c9847d7b7e67986415b8.svg";